<div class="layout__sidecol">
  <nav class="central-mainnav" id="app-bar-desktop">
    <ul class="central-mainnav__list list-unstyled">
      @if ((currentUser?.broker_id == 0 && !currentUser?.console_access)) {
        <li id="home" class="home" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">
          <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.DashboardLanding]">
            <svg class="icon">
              <use xlink:href="#dashboard-filled"></use>
            </svg>
            <span>Home</span>
          </a>
        </li>
      }
      <li id="policies" class="policies" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" [routerLink]=" (currentUser?.broker_id > 0 || currentUser?.console_access) ? ['/' + RouterLinks.PolicyHolders] : ['/' + RouterLinks.PoliciesLanding]">
          <svg class="icon">
            <use xlink:href="#policies-filled"></use>
          </svg>
          <span>Policies</span>
        </a>
      </li>
      <li id="quotes" class="quotes" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" [routerLink]=" (currentUser?.broker_id > 0 || currentUser?.console_access) ? ['/' + RouterLinks.PolicyHolders] : ['/' + RouterLinks.QuoteLanding]">
          <svg class="icon">
            <use xlink:href="#quotes-filled"></use>
          </svg>
          <span>Quotes</span>
        </a>
      </li>

      <li id="claims" class="claims" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" [routerLink]=" (currentUser?.broker_id > 0 || currentUser?.console_access) ? ['/' + RouterLinks.PolicyHolders] : ['/' + RouterLinks.ClaimsLanding]">
          <svg class="icon">
            <use xlink:href="#claims-filled"></use>
          </svg>
          <span>Claims</span>
        </a>
      </li>
      <li id="more" class="more" [ngClass]="moreActiveDesktop ? 'is-active':null">
        <a href="javascript:;" (click)="activateMore('desktop')" id="sidesheet-appbar-more-trigger">
          <svg class="icon">
            <use xlink:href="#more-circle-filled"></use>
          </svg>
          <span>More</span>
        </a>
      </li>
    </ul>
  </nav>
  <!-- <div class="central-getassistance">
  <a href="javascript:;" (click)="startSOSFlow()" class="central-getassistance__btn"><svg class="icon">
    <use xlink:href="#navigation-sos"></use>
  </svg></a>
</div> -->
@if (subMenu) {
  <nav class="central-nav">
    <ul class="central-nav__list list-unstyled">
      <li [routerLink]="['/' + RouterLinks.PolicyOverview]" routerLinkActive="is-active">
        <a href="javascript:;">
          <span>Overview</span>
        </a>
      </li>
      <li [routerLink]="['/' + RouterLinks.PolicySummary]" routerLinkActive="is-active">
        <a href="javascript:;">
          <span>Summary</span>
        </a>
      </li>
      <li [routerLink]="['/' + RouterLinks.PolicyInsuredItems]" routerLinkActive="is-active" [ngClass]=" hasNotice ? 'has-notice' : null">
        <a href="javascript:;">
          <span>Insured Items</span>
        </a>
      </li>
      <li [routerLink]="['/' + RouterLinks.PolicyAddons]" routerLinkActive="is-active">
        <a href="javascript:;">
          <span>Benefits</span>
        </a>
      </li>
      <li [routerLink]="['/' + RouterLinks.PolicyPayment]" routerLinkActive="is-active">
        <a href="javascript:;">
          <span>Payments</span>
        </a>
      </li>
      <li [routerLink]="['/' + RouterLinks.PolicyResources]" routerLinkActive="is-active">
        <a href="javascript:;">
          <span>Documents</span>
        </a>
      </li>
    </ul>
  </nav>
}
@if (referral) {
  <nav class="central-nav">
    <ul class="central-nav__list list-unstyled">
      <li [ngClass]="!showDetails ? 'is-active':''" (click)="setDetail(false)">
        <a href="javascript:;">
          <span>Overview</span>
        </a>
      </li>
      <li [ngClass]="showDetails ? 'is-active':''" (click)="setDetail(true)">
        <a href="javascript:;">
          <span>Track your referrals</span>
        </a>
      </li>
    </ul>
  </nav>
}
</div>

@if (!subMenu) {
  <nav class="app-bar" [ngClass]="moreActiveMobile ? 'more-active':null" id="app-bar">
    <ul>
      <li [routerLinkActive]="'is-active'"  [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.DashboardLanding]">
          <svg class="icon">
            <use xlink:href="#dashboard-filled"></use>
          </svg>
          <span>Home</span>
        </a>
      </li>
      <li class="policies" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
        <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.PoliciesLanding]">
          <svg class="icon">
            <use xlink:href="#policies-filled"></use>
          </svg>
          <span>Policies</span>
        </a>
      </li>
      <li class="quotes" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
        @if (inProgress) {
          <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.QuoteLanding]">
            <svg class="icon">
              <use xlink:href="#quotes-filled"></use>
            </svg>
            <span>Quotes</span>
          </a>
        }
      </li>
      <li class="claims" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
        @if (inProgress) {
          <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.ClaimsLanding]">
            <svg class="icon">
              <use xlink:href="#claims-filled"></use>
            </svg>
            <span>Claims</span>
          </a>
        }
      </li>
      <li class="more" [ngClass]="moreActiveMobile ? 'is-active':null">
        <a href="#app-bar-more" (click)="activateMore('mobile')" data-toggle="modal">
          <svg class="icon">
            <use xlink:href="#more-circle-filled"></use>
          </svg>
          <span>More</span>
        </a>
      </li>
    </ul>
  </nav>
}

<div class="sidesheet-appbar" [ngClass]="moreActiveDesktop ? 'is-active':null" id="sidesheet-appbar-more">
  <div class="sidesheet-appbar__inner">
    <div class="sidesheet-appbar__body">

      <nav class="modal-appbar__menu">

        <div class="modal-appbar__menu-title"><small>Cover</small></div>
        <ul>
          <li class="membership" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:;" [routerLink]="['/' + RouterLinks.MembershipLanding]">
              <svg class="icon"><use xlink:href="#memberships"></use></svg>
              <span>Membership</span>
            </a>
          </li>
        </ul>
        <div class="modal-appbar__menu-title"><small>General</small></div>
        <ul>
          <li class="documents" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:;" [routerLink]="['/' + RouterLinks.Documents]">
              <svg class="icon"><use xlink:href="#document"></use></svg>
              <span>Documents</span>
            </a>
          </li>
          <li class="notifications" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:;" [routerLink]="['/' + RouterLinks.NotificationsLanding]">
              <svg class="icon"><use xlink:href="#notifications"></use></svg>
              <span>Notifications</span>
            </a>
          </li>
        </ul>

        <div class="modal-appbar__menu-title"><small>Extras</small></div>
        <ul>
          <li [ngClass]="referral ? 'is-active' : null">
            <a href="javascript:;" [routerLink]="['/' + RouterLinks.Referrals]">
              <svg class="icon"><use xlink:href="#share"></use></svg>
              <span>Referrals</span>
            </a>
          </li>

        </ul>
        <div class="modal-appbar__menu-title"><small>Support</small></div>
        <ul>
          <li>
            <a href="tel:0870952823">
              <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
              <span>Give us a call</span>
            </a>
          </li>
          <li>
            <a href="#" (click)="requestCall()" data-dismiss="modal" >
              <svg class="icon"><use xlink:href="#request-call"></use></svg>
              <span>Request a call</span>
            </a>
          </li>
          <li>
            <a href="#" data-dismiss="modal"  (click)="chat.toggle();">
              <svg class="icon"><use xlink:href="#chat"></use></svg>
              <span>Chat to us</span>
            </a>
          </li>
        </ul>

        <div class="modal-appbar__menu-title"><small>Resources</small></div>
        <ul>
          <li>
            <a href="https://www.everything.insure/tips-how-tos/" target="_blank">
              <svg class="icon"><use xlink:href="#video-screen"></use></svg>
              <span>Tips and how-tos</span>
            </a>
          </li>
          <li>
            <a href="https://www.everything.insure/faqs/" target="_blank">
              <svg class="icon"><use xlink:href="#q-a"></use></svg>
              <span>FAQs</span>
            </a>
          </li>
          <li>
            <a href="https://www.everything.insure/blog/" target="_blank">
              <svg class="icon"><use xlink:href="#blog"></use></svg>
              <span>Blog</span>
            </a>
          </li>
        </ul>

      </nav>
    </div>

  </div>
</div>

<div class="modal fade fade-up modal--fullscreen" id="app-bar-more" tabindex="-1" role="dialog" aria-labelledby="app-bar-more" aria-modal="true" >
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-appbar">
      <nav class="modal-appbar__menu">
        <div class="modal-appbar__menu-title"><small>Cover</small></div>
        <ul>
          <li>
            <a href="javascript:;" data-dismiss="modal"  [routerLink]="['/' + RouterLinks.MembershipLanding]">
              <svg class="icon"><use xlink:href="#memberships"></use></svg>
              <span>Membership</span>
            </a>
          </li>
        </ul>
        <div class="modal-appbar__menu-title"><small>General</small></div>
        <ul>
          <li>
            <a href="javascript:;" data-dismiss="modal"  [routerLink]="['/' + RouterLinks.Documents]">
              <svg class="icon"><use xlink:href="#document"></use></svg>
              <span>Documents</span>
            </a>
          </li>
          <li>
            <a href="javascript:;" data-dismiss="modal" [routerLink]="['/' + RouterLinks.NotificationsLanding]">
              <svg class="icon"><use xlink:href="#notifications"></use></svg>
              <span>Notifications</span>
            </a>
          </li>
        </ul>
        <div class="modal-appbar__menu-title"><small>Extras</small></div>
        <ul>
          <li>
            <a href="javascript:;" data-dismiss="modal" [routerLink]="['/' + RouterLinks.Referrals]">
              <svg class="icon"><use xlink:href="#share"></use></svg>
              <span>Referrals</span>
            </a>
          </li>

        </ul>

        <div class="modal-appbar__menu-title"><small>Support</small></div>
        <ul>
          <li>
            <a href="tel:0870952823">
              <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
              <span>Give us a call</span>
            </a>
          </li>
          <li>
            <a href="javascript:;" data-dismiss="modal" (click)="requestCall()" data=>
              <svg class="icon"><use xlink:href="#request-call"></use></svg>
              <span>Request a call</span>
            </a>
          </li>
          <li>
            <a href="javascript:;"  (click)="chat.toggle();">
              <svg class="icon"><use xlink:href="#chat"></use></svg>
              <span>Chat to us</span>
            </a>
          </li>
        </ul>

        <div class="modal-appbar__menu-title"><small>Resources</small></div>
        <ul>
          <li>
            <a href="https://www.everything.insure/tips-how-tos/" target="_blank">
              <svg class="icon"><use xlink:href="#video-screen"></use></svg>
              <span>Tips and how-tos</span>
            </a>
          </li>
          <li>
            <a href="https://www.everything.insure/faqs/" target="_blank">
              <svg class="icon"><use xlink:href="#q-a"></use></svg>
              <span>FAQs</span>
            </a>
          </li>
          <li>
            <a href="https://www.everything.insure/blog/" target="_blank">
              <svg class="icon"><use xlink:href="#blog"></use></svg>
              <span>Blog</span>
            </a>
          </li>
        </ul>

      </nav>
      <div class="modal-appbar__sos">
        <div class="modal-appbar__sos-inner">
          <a href="javascript:;" (click)="startSOSFlow()" class="button button--block button--lg button--primary">
            <svg class="icon">
              <use xlink:href="#navigation-sos"></use>
            </svg>
            Emergency Assistance
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<app-request-call #requestCallComponent></app-request-call>
